let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gCbq8")).then(() => parcelRequire('7rXEs'));